import React, { useState, useEffect } from "react";
import WishlistDrawer from "../../common/cartpage/WishlistDrawer";
import axios from "axios";
import Swal from "sweetalert2";

const Footer = () => {
  const [wishlistOpen, setWishlistOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const currentYear = new Date().getFullYear();
  const [settings, setSettings] = useState({
    logo: "/images/bird.png",
    favicon: "",
    footer_text: "",
    email: "coordinator@GURU.com",
    phone: "+91-98030 61407",
    facebook_url: "#",
    twitter_url: "#",
    instagram_url: "#",
    linkedin_url: "#",
    youtube_url: "#",
    meta_site_name: "",
    meta_description: "",
    meta_keyword: "",
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(
          "https://code.gurusport.in/api/menu"
        );
        if (!res.ok) throw new Error("Failed to fetch settings");
        const data = await res.json();
        if (data?.settings) {
          setSettings((prev) => ({
            ...prev,
            logo: data.settings.logo || prev.logo,
            favicon: data.settings.favicon || prev.favicon,
            footer_text: data.settings.footer_text || prev.footer_text,
            email: data.settings.email || prev.email,
            phone: data.settings.phone || prev.phone,
            facebook_url: data.settings.facebook_url || prev.facebook_url,
            twitter_url: data.settings.twitter_url || prev.twitter_url,
            instagram_url: data.settings.instagram_url || prev.instagram_url,
            linkedin_url: data.settings.linkedin_url || prev.linkedin_url,
            youtube_url: data.settings.youtube_url || prev.youtube_url,
            meta_site_name: data.settings.meta_site_name || prev.meta_site_name,
            meta_description:
              data.settings.meta_description || prev.meta_description,
            meta_keyword: data.settings.meta_keyword || prev.meta_keyword,
          }));
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchSettings();
  }, []);

  const handleSubscribe = async () => {
    if (!email) {
      Swal.fire("Oops!", "Please enter your email.", "warning");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://code.gurusport.in/api/subscribers",
        { email }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire("Thank you!", "You have successfully subscribed.", "success");
        setEmail(""); // clear input
      } else {
        Swal.fire("Oops!", "Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Subscription failed.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#F7F7F7] text-gray-800">
      {/* Newsletter Section */}
      <div className="bg-[#F7F7F7] border-t border-gray-200 pt-10 sm:pt-14 pb-8 sm:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">

            {/* Newsletter Card */}
            <div className="bg-white border border-gray-200/70 rounded-2xl p-6 sm:p-8 shadow-[0_6px_24px_-4px_rgba(16,24,40,0.12),0_2px_8px_-2px_rgba(16,24,40,0.07)] hover:shadow-[0_16px_40px_-8px_rgba(16,24,40,0.18),0_4px_12px_-4px_rgba(16,24,40,0.1)] transition-shadow duration-300">
              <span className="text-[#E8112D] uppercase tracking-[3px] text-[11px] font-semibold">
                Newsletter
              </span>

              <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mt-3 leading-snug">
                Get our emails for info on
                <br />
                new <span className="text-[#E8112D]">items, sales &amp; updates</span>.
              </h2>

              <p className="text-gray-600 text-sm mt-3 mb-6">
                Subscribe and stay updated with our latest products and exclusive
                offers.
              </p>

              <div className="flex flex-col sm:flex-row overflow-hidden rounded-lg border border-gray-200 bg-white focus-within:border-[#E8112D] transition-colors">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="w-full sm:flex-1 min-w-0 bg-transparent px-4 sm:px-5 py-3.5 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-0"
                />

                <button
                  onClick={handleSubscribe}
                  disabled={loading}
                  className="w-full sm:w-auto shrink-0 bg-[#E8112D] text-white font-semibold px-8 py-3.5 sm:py-0 hover:bg-[#c40e26] disabled:opacity-70 transition-colors duration-300"
                >
                  {loading ? "Subscribing..." : "Subscribe"}
                </button>
              </div>

              <p className="text-xs text-gray-400 mt-4">
                By subscribing, you agree to our Terms &amp; Conditions and Privacy
                Policy.
              </p>
            </div>

            {/* Help Card */}
            <div className="bg-white border border-gray-200/70 rounded-2xl p-6 sm:p-8 shadow-[0_6px_24px_-4px_rgba(16,24,40,0.12),0_2px_8px_-2px_rgba(16,24,40,0.07)] hover:shadow-[0_16px_40px_-8px_rgba(16,24,40,0.18),0_4px_12px_-4px_rgba(16,24,40,0.1)] transition-shadow duration-300 flex flex-col justify-center">
              <span className="text-[#E8112D] uppercase tracking-[3px] text-[11px] font-semibold">
                Support
              </span>

              <h3 className="text-xl font-bold text-gray-900 mt-3">
                Need Help?
              </h3>

              <p className="text-xl sm:text-2xl font-bold text-[#E8112D] mt-2 break-words">
                +{settings.phone}
              </p>

              <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                Available Monday - Saturday
                <br />
                10:00 AM – 6:00 PM
              </p>

              <div className="flex flex-wrap gap-3 sm:gap-4 mt-6">
                {[
                  { icon: "/icons/fb.svg", link: settings.facebook_url },
                  { icon: "/icons/instagram.svg", link: settings.instagram_url },
                  { icon: "/icons/youtube.svg", link: settings.youtube_url },
                  { icon: "/icons/twitter.svg", link: settings.twitter_url },
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-11 h-11 rounded-full bg-white border border-[#E8112D] flex items-center justify-center hover:bg-[#E8112D] hover:scale-105 transition-all duration-300 group"
                  >
                    <img
                      src={social.icon}
                      alt=""
                      className="w-4 h-4 [filter:invert(16%)_sepia(96%)_saturate(6000%)_hue-rotate(346deg)_brightness(95%)_contrast(105%)] group-hover:[filter:brightness(0)_invert(1)] transition-all duration-300"
                    />
                  </a>
                ))}
              </div>

              <p className="mt-5 text-gray-500 text-sm tracking-wide">
                GURU Social · Keep In Touch
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="bg-[#F7F7F7] pt-8 sm:pt-10 pb-6 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
        <div className="max-w-7xl mx-auto">
          <div className="relative">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-8 sm:gap-10 text-sm text-gray-600 relative z-10">
              {/* Column 1-2: Logo & Address */}
              <div className="col-span-2 sm:col-span-3 lg:col-span-2">
                <img
                  src={settings.favicon}
                  alt="Logo"
                  className="w-14 mb-5"
                />

                <p
                  className="leading-7 text-gray-600 overflow-hidden text-ellipsis max-h-28"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {settings.footer_text}
                </p>

                <p className="mt-5 text-gray-700 font-medium break-all">
                  {settings.email}
                </p>

                <p className="text-gray-700 font-medium break-words">
                  +{settings.phone}
                </p>
              </div>

              {/* Information */}
              {/* <div>
                <h4 className="text-[#E8112D] font-semibold tracking-wide uppercase text-[13px] mb-5">
                  Information
                </h4>

                <ul className="space-y-3">
                  <li>
                    <a
                      href="/about"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      About Us
                    </a>
                  </li>

                  <li>
                    <a
                      href="/privacypolicy"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Privacy Policy
                    </a>
                  </li>

                  <li>
                    <a
                      href="/deliveryreturnpolicy"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Delivery &amp; Returns
                    </a>
                  </li>

                  <li>
                    <a
                      href="/termsandconditions"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Terms &amp; Conditions
                    </a>
                  </li>

                  <li>
                    <a
                      href="/catalogue"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Catalogue
                    </a>
                  </li>
                </ul>
              </div> */}

              {/* Customer Support */}
              {/* <div>
                <h4 className="text-[#E8112D] font-semibold tracking-wide uppercase text-[13px] mb-5">
                  Customer Support
                </h4>

                <ul className="space-y-3">
                  <li>
                    <a
                      href="/sizechart"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Size Chart
                    </a>
                  </li>

                  <li>
                    <a
                      href="#"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Fit Guide
                    </a>
                  </li>

                  <li>
                    <a
                      href="/blogs"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Blog
                    </a>
                  </li>

                  <li>
                    <a
                      href="/fabricguide"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Fabric Guide
                    </a>
                  </li>

                  <li>
                    <a
                      href="/frequently-asked-questions"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      FAQ
                    </a>
                  </li>

                  <li>
                    <a
                      href="/contact"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Contact Us
                    </a>
                  </li>
                </ul>
              </div> */}

              {/* Account */}
              <div>
                <h4 className="text-[#E8112D] font-semibold tracking-wide uppercase text-[13px] mb-5">
                  Account
                </h4>

                <ul className="space-y-3">
                  <li>
                    <a
                      href="/userdashboard"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Dashboard
                    </a>
                  </li>

                  <li>
                    <a
                      href="/userorder"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      My Orders
                    </a>
                  </li>

                  <li>
                    <button
                      onClick={() => setWishlistOpen(true)}
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1"
                    >
                      My Wishlist
                    </button>
                  </li>

                  <WishlistDrawer
                    isOpen={wishlistOpen}
                    onClose={() => setWishlistOpen(false)}
                  />

                  <li>
                    <a
                      href="/userdashboard"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Track My Orders
                    </a>
                  </li>
                </ul>
              </div>

              {/* Useful Links */}
              {/* <div>
                <h4 className="text-[#E8112D] font-semibold tracking-wide uppercase text-[13px] mb-5">
                  Useful Links
                </h4>

                <ul className="space-y-3">
                  <li>
                    <a
                      href="/dealers"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Global Dealers
                    </a>
                  </li>

                  <li>
                    <a
                      href="#"
                      className="text-gray-600 hover:text-[#E8112D] transition-all duration-300 hover:translate-x-1 inline-block"
                    >
                      Proud Partners
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>

            {/* Bottom Bar */}
            <div className="relative z-10 mt-10 pt-6 border-t border-gray-200">
              <div className="flex flex-col lg:flex-row justify-between items-center gap-5 text-center lg:text-left">
                <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
                  <p className="text-gray-500 text-sm text-center lg:text-left">
                    © {currentYear}{" "}
                    <span className="text-[#E8112D]">Guru</span>. All
                    rights reserved.
                  </p>

                  <div className="flex items-center gap-3">
                    <img
                      src="/icons/mastercard.svg"
                      alt="MasterCard"
                      className="h-6"
                    />
                    <img
                      src="/icons/visa.svg"
                      alt="Visa"
                      className="h-6"
                    />
                    <img
                      src="/icons/wallet.svg"
                      alt="Wallet"
                      className="h-5"
                    />
                  </div>
                </div>

                <div className="flex flex-wrap justify-center items-center gap-3 text-sm">
                  <a
                    href="/privacypolicy"
                    className="text-[#E8112D] hover:underline transition-colors"
                  >
                    Privacy Policy
                  </a>

                  <span className="text-gray-300">|</span>

                  <a
                    href="/termsandconditions"
                    className="text-[#E8112D] hover:underline transition-colors"
                  >
                    Terms &amp; Conditions
                  </a>

                  <span className="text-gray-300">|</span>

                  <a
                    href="/deliveryreturnpolicy"
                    className="text-[#E8112D] hover:underline transition-colors"
                  >
                    Delivery &amp; Returns
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
